// src/steps.js
const steps = [
    // { id: 0, label: 'Login' },
    { id: 1, label: 'Choose Subject' },
    { id: 2, label: 'Enter Question' },
    { id: 3, label: 'Upload Answer' },
    { id: 4, label: 'Confirm Answer' },
    { id: 5, label: 'Results' }, // If applicable
  ];
  
  export default steps;